import { EventVersionList } from './versions.js';

export interface IEventAdditionalSitesCommon {
  mainColor: string;
  backgroundColor: string;
}

export interface IEventPlacesCommon {
  link: string;
}

export interface IEventCommon {
  clientId: string;
  version: EventVersionList;
  mainColor: string;
  buttonColor: string;
  backgroundColor: string;
  textFont: string;
  additionalSites: Array<IEventAdditionalSitesCommon>;
  headerFont: string;
  places: Array<IEventPlacesCommon>;
}

export class EventAdditionalSitesCommonClass
  implements IEventAdditionalSitesCommon
{
  mainColor: string;
  backgroundColor: string;

  constructor(event?: Partial<IEventAdditionalSitesCommon>) {
    this.mainColor = event?.mainColor ?? '';
    this.backgroundColor = event?.backgroundColor ?? '';
  }
}

export class EventPlacesCommonClass implements IEventPlacesCommon {
  link: string;

  constructor(event?: Partial<IEventPlacesCommon>) {
    this.link = event?.link ?? '';
  }
}

export class EventCommonClass implements IEventCommon {
  clientId: string;
  version: EventVersionList;
  mainColor: string;
  buttonColor: string;
  backgroundColor: string;
  textFont: string;
  additionalSites: Array<IEventAdditionalSitesCommon>;
  headerFont: string;
  places: Array<IEventPlacesCommon>;

  constructor(event?: Partial<IEventCommon>) {
    this.clientId = event?.clientId ?? '';
    this.version = event?.version ?? EventVersionList.WEDDINGAPP;
    this.mainColor = event?.mainColor ?? '#000000';
    this.buttonColor = event?.buttonColor ?? '#000000';
    this.backgroundColor = event?.backgroundColor ?? '#ffffff';
    this.textFont = event?.textFont ?? '';
    this.additionalSites = event?.additionalSites ?? [];
    this.headerFont = event?.headerFont ?? '';
    this.places = event?.places ?? [];
  }
}
